import { createSelector } from 'reselect';

import { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';

const baseLoadingSelector = (state: any) => state?.documents;

export const uploadProgressSelector = () =>
  createSelector(baseLoadingSelector, (documents) => documents?.downloadProgress || 0);

export const convertDocumentDataSelector = () =>
  createSelector(baseLoadingSelector, (documents) => {
    if (documents?.convertDocumentData) return documents?.convertDocumentData;
    const dataToConvert = localStorage.getItem(LOCAL_STORAGE_KEYS.DATA_TO_CONVERT);
    if (dataToConvert && !documents?.convertDocumentData) {
      try {
        const data = JSON.parse(dataToConvert);
        return data;
      } catch {
        // do nothing
      }
    }

    return documents?.convertDocumentData;
  });

export const convertMultipleDocumentDataSelector = () =>
  createSelector(baseLoadingSelector, (documents) => {
    if (documents?.convertMultipleDocuments) return documents?.convertMultipleDocuments;
    const dataToConvert = localStorage.getItem(LOCAL_STORAGE_KEYS.DATA_MULTIPLE_TO_CONVERT);
    if (dataToConvert && !documents?.convertMultipleDocuments) {
      try {
        const data = JSON.parse(dataToConvert);
        return data;
      } catch {
        // do nothing
      }
    }

    return documents?.convertMultipleDocuments;
  });

export const uploadedFileSelector = () => createSelector(baseLoadingSelector, (documents) => documents?.fileUpload);

export const translateDocumentDataSelector = () =>
  createSelector(baseLoadingSelector, (documents) => documents?.translateDocumentData);

export const editFilenameSelector = () =>
  createSelector(baseLoadingSelector, (documents) => {
    const dataToEdit = localStorage.getItem(LOCAL_STORAGE_KEYS.DATA_TO_EDIT);

    if (dataToEdit && !documents?.editFilename) {
      try {
        const data = JSON.parse(dataToEdit);
        return data?.file?.filename.replace(/\.[0-9a-z]+$/i, '') || '';
      } catch {
        // do nothing
      }
    }

    return documents?.editFilename.replace(/\.[0-9a-z]+$/i, '') || '';
  });

export const editDocumentDataSelector = () =>
  createSelector(baseLoadingSelector, (documents) => {
    const dataToEdit = localStorage.getItem(LOCAL_STORAGE_KEYS.DATA_TO_EDIT);

    if (dataToEdit && !documents?.editDocumentData) {
      try {
        const data = JSON.parse(dataToEdit);
        return data;
      } catch {
        // do nothing
      }
    }

    return documents?.editDocumentData;
  });

export const selectEditMultipleDocuments = createSelector(baseLoadingSelector, (documents) => {
  const dataToEdit = localStorage.getItem(LOCAL_STORAGE_KEYS.DATA_TO_EDIT);
  if (dataToEdit && !documents?.editDocumentsList) {
    return JSON.parse(dataToEdit);
  }
  return documents.editDocumentsList;
});

export const pdfFileContentSelector = () =>
  createSelector(baseLoadingSelector, (documents) => documents?.pdfFileContent);

export const documentByIdSelector = () => createSelector(baseLoadingSelector, (documents) => documents?.documentById);

export const documentsDataSelector = () =>
  createSelector(baseLoadingSelector, (documents) => documents?.documents?.data || []);

export const selectedFileSelector = () => {
  return createSelector(baseLoadingSelector, (documents) => documents?.selectedFile);
};

export const mergeDocumentsListSelector = () =>
  createSelector(baseLoadingSelector, (documents) => documents?.mergeDocumentsList);

export const editMultipleDocumentsListSelector = () =>
  createSelector(baseLoadingSelector, (documents) => documents?.editDocumentsList);

export const selectedFilesSelector = () => createSelector(baseLoadingSelector, (documents) => documents?.selectedFiles);

export const willDownloadBySSESelector = () =>
  createSelector(baseLoadingSelector, (documents) => documents?.willDownloadBySSE);
